module.exports = __webpack_public_path__ + "img/studyVideo.9487dad7.svg";